import React from 'react';
import { Filter } from 'lucide-react';
import { describeConditionalFormula } from '@/lib/conditionalFormula';

// Surfaces the underlying column + condition of a conditional-aggregation
// calc measure (SUM_IF, MEDIAN_IF, …) so stewards can read it in plain terms.
export function ConditionalFormulaBreakdown({ formula, compact = false, testId }) {
  const parts = describeConditionalFormula(formula);
  if (!parts.length) return null;
  return (
    <div className={compact ? 'mt-1 space-y-1' : 'mt-2 p-2 rounded-lg bg-indigo-500/5 border border-indigo-500/15 space-y-1.5'} data-testid={testId || 'conditional-formula-breakdown'}>
      {!compact && (
        <p className="text-[9px] text-muted-foreground uppercase tracking-wider flex items-center gap-1">
          <Filter className="w-2.5 h-2.5" /> Conditional logic
        </p>
      )}
      {parts.map((p, i) => (
        <div key={i} className="text-[10px] leading-snug" data-testid={`cond-part-${i}`}>
          <span className="text-indigo-400 font-medium">
            {p.label}{p.percentile ? ` (${p.percentile})` : ''}
          </span>
          <span className="text-muted-foreground"> of </span>
          <span className="font-mono text-emerald-400">{p.field}</span>
          {p.condition && (
            <>
              <span className="text-muted-foreground"> where </span>
              <span className="font-mono text-amber-400 break-words">{p.condition}</span>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
